import generatedRoutes from '@/config/generatedRoutes.json'

/** Clone before merging so repeated layout reads cannot duplicate children. */
export function mergeGeneratedMenus(base, generated = generatedRoutes) {
  const result = JSON.parse(JSON.stringify(base))
  const find = (nodes, path) => {
    for (const node of nodes) {
      if (node.path === path) return node
      const found = node.children && find(node.children, path)
      if (found) return found
    }
    return null
  }
  for (const item of generated) {
    if (find(result, item.path)) continue
    const parent = find(result, item.parent) || find(result, '/appset')
    const route = JSON.parse(JSON.stringify(item))
    delete route.parent
    if (parent) { parent.children = parent.children || []; parent.children.push(route) }
  }
  return result
}
